export const STANDARD_CANCELLATION = 'standard'
export const MODERATE_CANCELLATION = 'moderate'
export const STRICT_CANCELLATION = 'strict'
export const NO_REFUND = 'no_refund'
